import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SubscriptionPopupPayload {
    feature?: string;
    message?: string;
    upgradeReason?: string;
}

export interface SubscriptionPopupState {
    isOpen: boolean;
    lockedItem?: string;
    feature?: string;
    message?: string;
    upgradeReason?: string;
}

const initialState: SubscriptionPopupState = {
    isOpen: false
};

const SubscriptionPopupSlice = createSlice({
  name: "subscription-popup",
  initialState,
  reducers: {
    closePopup(state) {
      state.isOpen = false;
      delete state.lockedItem;
      delete state.feature;
      delete state.message;
      delete state.upgradeReason;
    },
    openPopup(state, action: PayloadAction<string | SubscriptionPopupPayload | undefined>) {
      state.isOpen = true;

      // Support both old string format and new object format
      if (typeof action.payload === 'string') {
        state.lockedItem = action.payload;
      } else if (action.payload) {
        state.feature = action.payload.feature;
        state.message = action.payload.message;
        state.upgradeReason = action.payload.upgradeReason;
        state.lockedItem = action.payload.feature; // For backwards compatibility
      }
    }
  },
});

export const { closePopup, openPopup } = SubscriptionPopupSlice.actions;
export const subscriptionPopupActions = SubscriptionPopupSlice.actions;
export default SubscriptionPopupSlice.reducer;
